﻿import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconListCheck } from "@tabler/icons-react";
import { RequisitosDef } from "./RequisitosDef";

export const RequisitosIcon = IconListCheck;
export const RequisitosHelpText = "* Aquí tendra la lista de todos los requisitos asignables.";
export class Requisitos extends Entity<RequisitosDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new RequisitosDef(), parentKeys);
        super.Form = import('./RequisitosForm').then((module) => module.RequisitosForm);
        this.Title = "Requisitos";
        this.Icon = RequisitosIcon;
        this.HelpText = RequisitosHelpText;
    }
}